import { Text } from "./text";

export default class InputsTextfield extends Text {
  public onInput(e) {
    if(this.opts.noDispatch){ return; }
    this.lag.start(e.target.value);
  }
}

riot.mixin("inputs.textfield", InputsTextfield as riot.TagMixin)
